/**
 * Tema claro/oscuro: persiste preferencia y aplica la clase `theme-dark` en `<html>`.
 */
import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

const STORAGE_KEY = 'mr-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly isDark = signal(false);

  /** `true` cuando el tema oscuro está activo. */
  readonly darkMode = this.isDark.asReadonly();

  /** Restaura la preferencia guardada (por defecto tema claro). */
  init(): void {
    const stored = this.readStoredPreference();
    this.applyTheme(stored === 'dark');
  }

  /** Alterna entre tema claro y oscuro. */
  toggle(): void {
    this.applyTheme(!this.isDark());
  }

  /** Etiqueta accesible para el botón de alternancia. */
  toggleLabel(): string {
    return this.isDark() ? 'Activar modo claro' : 'Activar modo oscuro';
  }

  private readStoredPreference(): 'light' | 'dark' {
    if (typeof localStorage === 'undefined') {
      return 'light';
    }
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'light';
  }

  private applyTheme(dark: boolean): void {
    this.isDark.set(dark);
    const root = this.document.documentElement;
    root.classList.toggle('theme-dark', dark);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    }
  }
}
